export const APP_NAME = "Giulia CRM"
